export default __webpack_public_path__ + "static/media/calIIcon.c7435a5b.svg";